module.exports = __webpack_public_path__ + "img/SHOW_IN_POPUP.8ac8e704.svg";